<template>
    <div>

        <!-- <el-card class="search-form-card">
            <el-form :inline="true" :model="formData" class="search-form">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="服务组:">
                            <el-select v-model="form.service_group" placeholder="请选择" style="width: 160px">
                                <el-option v-for="item in serviceGroupList" :key="item.ename" :label="item.cname"
                                           :value="item.ename"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="日期:">
                            <el-date-picker
                                v-model="createTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button type="primary" @click="loadData">查询</el-button>
                            <el-button type="primary" @click="reset">重置</el-button>
                            <el-button @click="exportTable('personStatis','人员统计')" type="primary">导出表格</el-button>
                            <el-button @click="exportTable('personStatis','人员统计')" type="primary">录入工时</el-button>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
        </el-card> -->
        <el-card>

            <el-table :data="tableData" v-loading="loading" id="personStatis">
                <el-table-column label="序列" width="70" align="center" fixed>
                    <template slot-scope="scope">
                        <span> {{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="人员姓名" prop="worker_cname" fixed align="center"></el-table-column>
                <el-table-column label="项目名称" prop="project_name">
                    <template slot-scope="scope">
                        {{ scope.row.project_name | tableVal(projectName) }}
                    </template>
                </el-table-column>
                <el-table-column label="工作日期" prop="work_date" fixed align="center"></el-table-column>
                <el-table-column label="开始时间" prop="start_time" fixed align="center"></el-table-column>
                <el-table-column label="结束时间" prop="end_time" fixed align="center"></el-table-column>
                <el-table-column label="工作时长（小时）" prop="time_length_h" fixed align="center"></el-table-column>
                <el-table-column label="工作内容" prop="job_content" fixed align="center"></el-table-column>
                <el-table-column label="备注" prop="comment" fixed align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!-- <router-link :to="{ path: '/nonWorkOrderDetail',
                                     query: { workerId:scope.row.id,callback:request,types:'edit'}}">
                            <el-button type="text" class="hoverBtn">编辑</el-button>
                        </router-link> -->
                        <router-link :to="{ path: '/nonWorkOrderDetail',
                                 query: { workerId:scope.row.id,workerCname:scope.row.worker_cname,callback:request,types:'edit' }}">
                            <el-button type="text" class="hoverBtn">编辑</el-button>
                        </router-link>
                        <el-button type="text" size="small" @click="deleteEvent(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="formData.page_index"
                :page-size="formData.page_size"
                :page-sizes="[10, 20, 30, 40]"
                :total="total"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    import services from "./nonWorkOrder.service";
    export default {
        // props:{

        //     usereName:String,
        //     callback:Function
        // },
        data() {
            return {
                formData:{
                    page_index:1,
                    page_size:10,
                    start_date:'',
                    end_date:'',
                    worker:'',
                },
                total: 0,
                tableData:[],
                loading:true,
                serviceGroupList:[],     // 问题分类
                createTime:[],
            }
        },
        created() {

            // console.log(this.$route.query)
            this.formData.worker = this.$route.query.usereName
            if(this.$route.query.timeSearch.length >0){
                this.formData.start_date = this.$route.query.timeSearch[0]
                this.formData.end_date = this.$route.query.timeSearch[1]
            }

            this.request();
            // this.getServiceGroupList();
        },
        computed:{

            dictionary(){
                return this.$store.state.dictionary;
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },

        },
        methods: {
            exportTable(id,name,startTime='',endTime=''){
                this.$exportTable(id,name,startTime,endTime)
            },
            loadData(){
                this.loading = true;
                this.form={
                    ...this.form,
                    start_date: this.createTime[0],
                    end_date:this.createTime[1]
                }
                // console.log(this.form);
                this.request();
            },
            deleteEvent(workerID){
                this.$confirm('确定要删除吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    services.nonOrderDele({work_id:workerID}).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                          });
                        this.request()
                    }).catch(err => {
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消删除'
                  });
                });
            },
            request(){
                // 获取列表数据
                services.getNonWorkList(this.formData).then(res => {
                    this.tableData = res.list;
                    this.total = res.total
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 页数改变时
            handleSizeChange(val) {
                // this.deployData = [];
                let pages = Math.ceil(this.total / val);
                this.formData.page_size = val;
                if (this.formData.page_index > pages) {
                    this.formData.page_index = 1;
                }
                this.deployLoading = true;
                this.request();
            },

            // 页码改变时
            handleCurrentChange(val) {
                // this.deployData = [];
                this.formData.page_index = val;
                this.deployLoading = true;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.hoverBtn{
    :hover{
        // font-size:18px;
    }
    padding:10px 30px;

}
.titleColod{
    color:#0099FF;
}
p{
    line-height: 20px;
}
</style>
